export enum State {
	UNDER_REVIEW = 'En étude',
	PENDING = 'En attente',
	ON_THE_WAY = 'En route',
	IN_PROGRESS = 'En cours',
	FINISHED = 'Terminée',
	CANCELED = 'Annulée',
	CANCELED_FOR_EMPLOYEE = 'Annulée (intervenant absent)',
	CANCELED_FOR_BENEFICIAIRE = 'Annulée (bénéficiaire absent)',
	CANCELED_PLANNING_ERROR = 'Annulée (erreur de planning)',
	CANCELED_TYPING_ERROR = 'Annulée (erreur de saisie)',
	CANCELED_INTERVENTION_MODIFY = "Annulée (modifications d'intervention)",
	CANCELED_POSTPONEMENT = 'Annulée (report de date)',
	CANCELED_FOR_PRESCRIBER = 'Annulée (par le prescripteur)',
}
